import type { ReactNode } from 'react'

export function AdminPageHeader({ title, description, actions }: { title: string; description?: string; actions?: ReactNode }) {
  return (
    <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 className="m-0 text-xl font-semibold" style={{ color: 'var(--text)' }}>{title}</h1>
        {description ? <p className="mt-1 text-xs" style={{ color: 'var(--text-muted)' }}>{description}</p> : null}
      </div>
      {actions}
    </div>
  )
}

export function AdminCard({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <section className={`rounded-xl border p-4 ${className}`} style={{ background: 'var(--bg-card)', borderColor: 'var(--border)' }}>
      {children}
    </section>
  )
}

export function AdminInput(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`h-9 rounded-md border px-3 text-xs outline-none ${props.className ?? ''}`} style={{ background: 'var(--bg-input)', borderColor: 'var(--border)', color: 'var(--text)', ...props.style }} />
}

export function AdminSelect(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={`h-9 rounded-md border px-3 text-xs outline-none ${props.className ?? ''}`} style={{ background: 'var(--bg-input)', borderColor: 'var(--border)', color: 'var(--text)', ...props.style }} />
}

export function Money({ cents }: { cents: number | null }) {
  return <>{cents === null ? '—' : new Intl.NumberFormat(undefined, { style: 'currency', currency: 'BRL' }).format(cents / 100)}</>
}
